var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 4.135 4.135 1 8 1C11.865 1 15 4.135 15 8C15 11.865 11.865 15 8 15C4.135 15 1 11.865 1 8ZM3.61001 7.785C4.73001 7.975 5.60501 8.315 6.28001 8.69C7.27001 7.48 8.73501 5.695 11.695 4.595L11.89 4.915C10.405 6.26 8.77001 8.265 7.90501 9.985C7.71001 10.365 7.47001 10.95 7.24001 11.565C6.93251 11.5675 6.77376 11.5663 6.61501 11.565C6.45626 11.5638 6.29751 11.5625 5.99001 11.565C5.78001 11.025 5.54001 10.535 5.28501 10.125C4.69501 9.18 3.97501 8.52 3.46501 8.125C3.52383 7.98382 3.53037 7.96875 3.56905 7.87956C3.57969 7.85503 3.59275 7.8249 3.61001 7.785Z",
    fill: "#328714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFilled);
export default __webpack_public_path__ + "static/media/Checkmark-filled.1732d55f6473671999bf5505ec72ea77.svg";
export { ForwardRef as ReactComponent };